import { SpinnerLoader } from "@/components/designSystem/Loaders/SpinnerLoader"

export const Loader = () => {
  return (
    <div className="flex border-r py-6 pl-12 pr-0">
      <div className="h-20 w-full"> {<SpinnerLoader />}</div>
    </div>
  )
}
